import { SbbOption } from "@sbb-esta/lyne-react/option";
import { SbbSelect } from "@sbb-esta/lyne-react/select";
import { LyneFormField } from "components/Lyne/LyneFormField";
import { SendToTargetMeeting } from "models/SendToTargetMeeting";
import { useTranslations } from "providers";

interface SendToFormMeetingProps {
  selected?: boolean;
  meetingId?: number;
  meetings?: SendToTargetMeeting[];
  onChange?: (meetingId: number) => void;
}

export const SendToFormMeeting = ({ selected, meetingId, meetings, onChange }: SendToFormMeetingProps) => {
  const i18n = useTranslations();
  const options = [...(meetings || [])].sort((a, b) => a.date.localeCompare(b.date));

  if (!options.length) {
    return <span>{i18n.SendToPanel_Meeting_NoDataTemplate}</span>;
  }

  return (
    <div style={{ width: "100%" }} className={selected ? "" : "disabled"}>
      <LyneFormField size="m" name="SendToPanel_Meeting" label={undefined} contextHelp={undefined}>
        <SbbSelect
          placeholder={i18n.SendToPanel_Meeting_Placeholder}
          disabled={!selected}
          value={meetingId?.toString()}
        >
          {options.map((option) => {
            const id = option.id;
            const optionValue = id.toString();
            const isSelected = id === meetingId;

            return (
              <SbbOption key={id} value={optionValue} selected={isSelected} onClick={() => onChange?.(id)}>
                {option.title}
              </SbbOption>
            );
          })}
        </SbbSelect>
      </LyneFormField>
    </div>
  );
};
